<div mat-dialog-content>
    <div class="row" *ngIf="dataSource.data.length<=0">
        <div class="col-sm-12 text-danger">
                No SPRA Request Found.
            </div>
    </div>

    <div class="card text-center" *ngIf="dataSource.data.length>0">
        <div class="card-header bg-primary text-left text-white font-weight-bold">
            OPS List
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control" (keyup)="doFilter($event)" placeholder="Filter">
                    </div>
                </div>

                <div class="col-sm-12">
                    <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc" multiTemplateDataRows>
                        <!-- Name Column -->
                        <ng-container matColumnDef="RequestNo">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> SPRA No. </mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="OnSpraClick(element)" class="btn-link text-primary"> {{element.RequestNo}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="RequestedDate">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Requested Date </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.RequestedDate}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="RequestedBy">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Requested By </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.RequestedBy}} </mat-cell>
                        </ng-container>                        

                        <!-- Position Column -->
                        <ng-container matColumnDef="PartyName">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Party Name </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.PartyName}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="SaleType">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Type </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.SaleType}} </mat-cell>
                        </ng-container>


                       
                        <mat-header-row *matHeaderRowDef="SpraListHeader"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: SpraListHeader;"></mat-row>

                    </mat-table>
                </div>

                <div class="col-sm-12 float-right text-right">
                    <!-- <div class="col-sm-12 > -->
                        <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
                        </mat-paginator>
                    <!-- </div> -->
                </div>
            </div>
        </div>

    </div>

</div>